import { CartItem } from '../../core/data/quote/cart/types'
import { getPriceValues } from '../../core/resources/helpers/index'
import { ProductData } from '../../types/index'

export const getGa4ItemsFromMagentoItemFragment = ({
  cartItems
}: {
  cartItems: CartItem[]
}) => {
  return (
    cartItems?.map((item, index) => {
      const isConfigurableProduct =
        item?.product.typeName === 'ConfigurableCartItem'

      const [amount, currency] =
        isConfigurableProduct && item?.variantProduct?.price
          ? getPriceValues(item?.variantProduct?.price)
          : getPriceValues(item?.product?.price)

      const price = amount ?? 0

      return {
        index,
        currency,
        item_id: item?.product.sku ?? '',
        item_name: item?.product.name ?? '',
        discount: item?.prices?.total_item_discount?.value ?? 0,
        item_category:
          item?.product.categories?.[0]?.breadcrumbs?.[0]?.category_name ??
          undefined,
        item_category2:
          item?.product.categories?.[1]?.breadcrumbs?.[0]?.category_name ??
          undefined,
        item_category3:
          item?.product.categories?.[2]?.breadcrumbs?.[0]?.category_name ??
          undefined,
        item_category4:
          item?.product.categories?.[3]?.breadcrumbs?.[0]?.category_name ??
          undefined,
        item_category5:
          item?.product.categories?.[4]?.breadcrumbs?.[0]?.category_name ??
          undefined,
        item_variant: isConfigurableProduct
          ? item?.variantProduct?.sku ?? ''
          : undefined,
        price,
        quantity: item?.quantity ?? 0
      }
    }) ?? []
  )
}

export const getGa4ItemsFromMagentoProductFragment = ({
  products
}: {
  products: ProductData[]
}) => {
  return (
    products.map((product, index) => {
      return {
        item_id: product?.sku ?? '',
        item_name: product?.name ?? '',
        item_category: product?.categories?.[0]?.name ?? undefined,
        item_category2: product?.categories?.[1]?.name ?? undefined,
        item_category3: product?.categories?.[2]?.name ?? undefined,
        item_category4: product?.categories?.[3]?.name ?? undefined,
        item_category5: product?.categories?.[4]?.name ?? undefined
      }
    }) ?? []
  )
}
